export enum AUTH_ERROR_STATUS {
  UNAUTHORIZED = 401,
  FORBIDDEN = 403
}
